/**
 * calculate
 * @param {*} setResults 
 * @param {*} state 
 * @returns 
 */
const calculate = (setResults, state) => {

   const { capsuleCount, excipientPackStat, apiList } = state;


   let results = {};

   //Amount of API (g)
   //dimensional analysis: mg * g/mg * 1 = g
   const mgTog = 1 / 1000; //g/mg
   results.apiList = apiList.map(item => item.quantity * mgTog * capsuleCount);

   //Excipient per Capsule (mg)
   //dimensional analysis: mg * 1 = mg
   results.excipientCapsule = excipientPackStat * (1 - apiList.reduce((acc,item) => (acc + (item.quantity/item.packStat)),0));

   //Excipient Total (g)
   //dimensional analysis: mg * g/mg * 1 = g
   results.excipientTotal = results.excipientCapsule * mgTog * capsuleCount;


   setResults(results);
   return results;
};

export default calculate;